<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between align-items-center catalogo-text text-sm"
          >
            Catálogo de operadores
            <router-link :to="{ name: 'NuevoOperador' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Operador
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #clave="{item}">
                <td class="py-2">{{ item.payload.clave }}</td>
              </template>
              <template #trabajador_id="{item}">
                <td class="py-2">{{ item.payload._relaciones.trabajador ? item.payload._relaciones.trabajador.payload.nombre : '' }}</td>
              </template>
              <template #cubetas="{item}">
                <td class="py-2">
                  {{ item.payload.cubetas.join(',') }}
                </td>
              </template>
              <template #check-header>
                <div class="text-center" @click="selectAll()">
                  <CIcon v-if="allSelections" name="cil-x-circle" />
                  <CIcon v-else name="cil-check" />
                </div>
              </template>
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      @input="searchTimeOut()"
                      placeholder="Búsqueda por clave..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-print" />
                        </CButton>
                      </template>

                      <CDropdownItem
                        @click="onClickPrintCubetas"
                        class="no-padding"
                      >
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir Cubetas
                        </div>
                      </CDropdownItem>
                      <CDropdownItem @click="onClickPrintOperadores" class="no-padding">
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir Operadores
                        </div>
                      </CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #check="{item}">
                <td class="py-2 custom-control custom-checkbox">
                  <p-check
                    class="p-svg p-curve"
                    name="check"
                    color="success"
                    v-model="item.selected"
                  >
                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                      <path
                        d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        style="stroke: white;fill:white"
                      />
                    </svg>
                    Imprimir
                  </p-check>
                </td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditarOperador',
                      params: { id: item.id }
                    }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Operador"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el operator {{ itemModal.clave }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Operador</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteOperador(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      :show.sync="printModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Cubetas"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrint.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Cubetas</h5>
        <CButtonClose @click="printModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModal = false" color="danger">Cancelar</CButton>
        <CButton @click="printCubetas()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="printModalOperadores"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Operadores"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrintOperadores.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Operadores</h5>
        <CButtonClose @click="printModalOperadores = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModalOperadores = false" color="danger">Cancelar</CButton>
        <CButton @click="printOperadores()" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PrettyCheck from "pretty-checkbox-vue/check";

const fields = [
  { key: "clave", label: "Clave", _style: "width:20%" },
  { key: "trabajador_id", label: "Trabajador", _style: "width:40%"},
  { key: "cubetas", label: "Cubetas", _style: "width:40%" },
  {
    key: "check",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Operadores",
  components: {
    vSelect,
    "p-check": PrettyCheck
  },
  data() {
    return {
      items: [],
      fields,
      filter: "",
      printModal: false,
      printModalOperadores: false,
      dropdownCustom: false,
      cancelModal: false,
      itemModal: { id: "", clave: "", index: "" },
      itemModalPrint: { cantidadCopias: 1 },
      itemModalPrintOperadores: { cantidadCopias: 1 },
      isLoading: false,
      allSelections: false,
      error: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    window.printSetup();
    this.actualizarInfo()
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
    },
    printers() {
      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
    },
    filteredItems() {
      return this.items.filter(i =>
        i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },
  watch: {
    ubicacionRaiz() {
      this.actualizarInfo();
    }
  },
  methods: {
    actualizarInfo(){
      this.isLoading = true;
      this.$store.dispatch("customHTTP", {
          schema: "operadores",
          limit: 50,
          page: 1,
          ["with-storage"]: ["*"]
      }).then(res => {
        this.items = res.data;
        this.pages = res.paginate.last_page;
        this.page = res.paginate.current_page;
      })
      .catch(err => console.log(err))
      .finally(() => (this.isLoading = false));
    },
    onClickPrintCubetas() {
      this.printModal = true;
      this.closeDropdown();
    },
    onClickPrintOperadores() {
      this.printModalOperadores = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text, page =1) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          'with-storage': ['*'],
          schema: "operadores",
          limit: 50,
          page: page,
          filter: {
            orwhere: [
              {
                field: "cat_operadores.payload->clave",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "cat_operadores.payload->cubetas",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ],
            orWhereJoin: [
              {
                field: "trabajador.payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.updateItemsSearch(this.filter.toUpperCase(),event)
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printCubetas() {
      const idsToPrint = this.items.filter(item => item.selected === true);

      idsToPrint.length
        ? idsToPrint.map(operador => {
            operador.payload.cubetas.map(cubeta => {
              this.printData('C' + operador.payload.clave + cubeta, this.itemModalPrint.cantidadCopias);
            })
          })
        : null;

      this.printModal = false;
    },
    printOperadores() {
      const idsToPrint = this.items.filter(item => item.selected === true);

      idsToPrint.length
        ? idsToPrint.map(operador => {
            this.printData('O' + operador.payload.clave, this.itemModalPrintOperadores.cantidadCopias, '70,20');
          })
        : null;

      this.printModalOperadores = false;
    },
    printData(data, cant, pos = '20,20') {
      if (data && cant && cant > 0) {
        window.printTicket(
          `^XA^FO${pos}^BY3^BCN,100,Y,N, ^FD${data}^PQ${cant}^XZ`
        );
      }
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        clave: item.payload.clave,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteOperador(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "operadores",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.actualizarInfo()
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
